export const inputCls =
  "w-full border border-white/15 bg-[#0A0A0A] px-3.5 py-2.5 text-sm text-white placeholder:text-zinc-600 outline-none transition-[border-color,box-shadow] duration-300 focus:border-[#E60000] focus:shadow-[0_0_0_3px_rgba(230,0,0,0.15)]";

export const labelCls = "mb-1.5 block text-[10px] font-semibold uppercase tracking-[0.25em] text-zinc-500";

export const Field = ({ label, testId, ...props }) => (
  <label className="block">
    <span className={labelCls}>{label}</span>
    <input data-testid={testId} className={inputCls} {...props} />
  </label>
);

export const SectionTitle = ({ children, hint }) => (
  <div className="mb-6">
    <h2 className="font-display flex items-center gap-4 text-lg font-semibold uppercase tracking-[0.25em] text-white">
      {children}
      <span className="h-px flex-1 bg-white/10" />
    </h2>
    {hint && <p className="mt-2 text-xs text-zinc-500">{hint}</p>}
  </div>
);
